import { BounceLoader } from "react-spinners";
import CommonDialog from "./CommonDialog";
import styles from "./confirmDialog.module.scss";

export interface ConfirmationDialogProps {
	onCloseDialog: () => void;
	title: React.ReactNode | string;
	description: React.ReactNode | string;
	onConfirm: () => void;
	actionLoading: boolean;
	btnText: React.ReactNode | string;
	btnBackGround?: string
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ onCloseDialog, title, description, onConfirm, btnText, actionLoading, btnBackGround }) => {
	return (
		<CommonDialog onCloseDialog={onCloseDialog}>
			<div className={styles.container}>
				<div className={styles.title}>
					{title}
					{/* Are you sure you want to {product.isPaused ? "unpause" : "pause"} this product? */}
				</div>
				<div className={styles.description}>
					{description}
					{/* {product.isPaused ? "Unpausing" : "Pausing"} a product will make it {product.isPaused ? "available" : "unavailable"}  for purchase by customers. */}
				</div>
				<div className={styles.buttonContainer}>
					<button disabled={actionLoading} className={`standardButton ${styles.button} ${styles.pauseButton}`} style={{backgroundColor: btnBackGround}} onClick={onConfirm}>
						{/* {product.isPaused ? "Unpause" : "Pause"} */}
                        {btnText}   {actionLoading && <BounceLoader  size={20} color="#fff" />}
					</button>
					<button className={`standardButton ${styles.button}`} onClick={onCloseDialog}>
						Cancel
					</button>
				</div>
			</div>
		</CommonDialog>
	);
};

export default ConfirmationDialog;
